// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"645":"1a54e560","967":"93703a76"}[chunkId] + ".chunk.css";
};